import { columnHelper } from './helper';

export const username = columnHelper.accessor('username', {
  header: 'Username',
});
